var _defs, _polygon, _polygon2, _path, _path2, _path3, _polygon3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEvoroadsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_1",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 994 191",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_14-5);\n      }\n\n      .cls-2 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_14-4);\n      }\n\n      .cls-3 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_14-3);\n      }\n\n      .cls-4 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_14-2);\n      }\n\n      .cls-5 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-2);\n      }\n\n      .cls-6 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12-3);\n      }\n\n      .cls-7 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_11);\n      }\n\n      .cls-8 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_14);\n      }\n\n      .cls-9 {\n        fill: url(#_\u0411\u0435\u0437\u044B\u043C\u044F\u043D\u043D\u044B\u0439_\u0433\u0440\u0430\u0434\u0438\u0435\u043D\u0442_12);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 14",
    x1: 59.96,
    y1: 95,
    x2: 614.3,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9f2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#ea8c49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#cb7076"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#b1589b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9d46b8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#8f39cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#8631d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#842fdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#7f31de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#7039e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#5947e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#385af1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#0e72fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0677ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 14",
    x1: 62.13,
    x2: 607.57,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 12",
    x1: 46.82,
    y1: 95,
    x2: 935.29,
    y2: 95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9f2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#bc628b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#842fdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#8031de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#7437e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#6043e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#4552ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#2266f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0677ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-2",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 12",
    x1: 42.53,
    x2: 930.78,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 12",
    x1: 40.62,
    y1: 95,
    x2: 934.58,
    y2: 95,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_11",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 11",
    x1: 52.72,
    y1: 133.16,
    x2: 934.25,
    y2: 133.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff9f2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2933d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#d87c63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#c16784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ae55a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9e47b6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#923cc7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#8a34d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#8530db"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#842fdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#7f31de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#7039e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#5947e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#385af1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#0e72fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0677ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14-3",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 14",
    x1: 59.44,
    y1: 95,
    x2: 619.73,
    y2: 95,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14-4",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 14",
    x1: 58.1,
    y1: 95,
    x2: 607.7,
    y2: 95,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14-5",
    "data-name": "\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439 \\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442 14",
    x1: 69.19,
    y1: 72.61,
    x2: 610.27,
    y2: 72.61,
    xlinkHref: "#_\\u0411\\u0435\\u0437\\u044B\\u043C\\u044F\\u043D\\u043D\\u044B\\u0439_\\u0433\\u0440\\u0430\\u0434\\u0438\\u0435\\u043D\\u0442_14"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "44.05 152.68 122.12 152.68 125.74 135.35 68.64 135.35 75.41 103.67 117.83 103.67 121.46 86.34 79.04 86.34 85.81 54.65 142.91 54.65 146.54 37.32 68.48 37.32 44.05 152.68"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "247.04 37.32 194.39 124.63 178.89 37.32 157.26 37.32 179.05 152.68 199.35 152.68 269.81 37.32 247.04 37.32"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M675.61,37.32l-70.63,115.36h22.11l16.01-26.57h48.84l4.95,26.57h20.64l-21.63-115.36h-20.29ZM652.51,108.78l29.04-49.01,8.24,49.01h-37.29Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M847.57,82.05c0-8.91-2-16.75-6.02-23.51-4.02-6.77-9.82-11.99-17.41-15.68-7.59-3.69-16.61-5.53-27.06-5.53h-38.62l-24.42,115.36h38.45c19.91,0,36.27-4.89,49.1-14.69,12.81-9.79,21.09-24.31,24.83-43.57.77-3.96,1.16-8.09,1.16-12.38ZM825.29,94.43c-2.75,12.98-8.36,23.05-16.83,30.2-8.47,7.15-19.7,10.73-33.67,10.73h-16.18l17.17-80.7h18.31c11.23,0,19.47,2.39,24.75,7.18,5.28,4.78,7.92,11.52,7.92,20.21,0,3.74-.5,7.87-1.49,12.38Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M889.41,55.73c4.35-2.58,10.04-3.88,17.08-3.88,9.8,0,18.97,2.31,27.56,6.93l3.8-17.49c-4.4-2.2-9.08-3.82-14.03-4.87-4.94-1.05-10.72-1.57-17.32-1.57-8.03,0-15.41,1.32-22.11,3.96-6.71,2.64-12.29,6.38-16.75,11.22-4.46,4.84-7.35,10.4-8.67,16.67-.44,1.88-.66,3.96-.66,6.27,0,6.16,2.07,11.53,6.2,16.09,4.13,4.57,10.04,8.56,17.74,11.96,8.46,3.74,14.27,6.74,17.41,9,3.14,2.26,4.7,5.19,4.7,8.83,0,1.21-.17,2.48-.5,3.8-.99,4.84-3.65,8.64-8,11.39-4.35,2.75-10.31,4.13-17.91,4.13-12.44,0-23.6-2.64-33.5-7.92l-3.8,17.99c3.85,2.09,8.97,3.77,15.35,5.04,6.37,1.27,12.98,1.9,19.8,1.9,14.85,0,26.46-2.81,34.82-8.42,8.35-5.61,13.64-13.59,15.84-23.93.55-2.97.83-5.34.83-7.1,0-6.27-2.06-11.5-6.19-15.68-4.13-4.18-10.42-8.19-18.9-12.05-5.94-2.64-10.26-4.7-12.95-6.19-2.7-1.49-4.79-3.1-6.27-4.86-1.49-1.76-2.22-3.91-2.22-6.44,0-1.21.17-2.48.5-3.8,1.1-4.73,3.82-8.39,8.17-10.97Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "436.13 155.16 422.92 111.16 400.15 111.16 391.35 155.16 436.13 155.16"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M394.52,35s-58.94-.16-60.49-.16c-12,0-23.16,2.5-33.5,7.51-10.35,5.01-19.04,12.07-26.08,21.21-7.04,9.14-11.83,19.64-14.36,31.52-1.1,5.5-1.65,10.22-1.65,14.19,0,9.24,2.09,17.33,6.27,24.27,4.18,6.92,10.04,12.26,17.58,16,7.53,3.74,16.26,5.61,26.16,5.61,12.32,0,23.6-2.5,33.83-7.51,10.24-5.01,18.84-12.05,25.83-21.13,5.87-7.62,10.07-16.3,12.79-25.9l13.62-65.61ZM361.26,95.08c-1.76,8.25-5.09,15.49-9.98,21.7-4.9,6.22-10.73,11-17.49,14.35-6.77,3.36-13.84,5.04-21.21,5.04-21.9,0-32.84-9.3-32.84-27.9,0-4.06.5-8.46,1.49-13.2,1.76-8.14,5.06-15.32,9.9-21.54,4.84-6.22,10.67-11.03,17.49-14.44,6.82-3.41,13.97-5.12,21.46-5.12,11,0,19.2,2.45,24.59,7.34,5.39,4.9,8.09,11.92,8.09,21.04,0,3.85-.5,8.09-1.49,12.71Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M609.31,56.8c-2.64-4.38-6.11-7.91-6.11-7.91-3.28-3.34-7.13-6.12-11.55-8.34-6.54-3.29-13.93-5.07-22.07-5.51-.06-.04-.24-.16-.28-.19h-117.14c6.33,1.02,11.56,3.09,15.5,6.36,5.72,4.76,8.58,11.71,8.58,20.88,0,3.48-.39,7.01-1.16,10.61-1.87,8.94-5.54,16.56-10.97,22.88-5.45,6.32-12.3,10.76-20.55,13.31l14.02,46.26h86.3c.31-.05.58-.18.88-.23,10.56-.55,20.35-2.9,29.31-7.28,10.23-5,18.84-12.05,25.83-21.12,3.26-4.23,11.37-15.02,14.27-31.44.27-1.55,3.96-23.67-4.86-38.29ZM589.91,95.09c-1.76,8.25-5.1,15.48-9.99,21.7-4.9,6.22-10.72,11.01-17.49,14.36-6.77,3.36-13.84,5.04-21.21,5.04-21.89,0-32.84-9.29-32.84-27.89,0-4.07.5-8.47,1.49-13.2,1.76-8.14,5.06-15.32,9.91-21.54,4.83-6.21,10.66-11.03,17.49-14.44,6.82-3.41,13.98-5.12,21.46-5.12,11.01,0,19.2,2.45,24.6,7.35,5.38,4.9,8.08,11.91,8.08,21.04,0,3.85-.49,8.09-1.47,12.71Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.31,55.47c-3.08-2.09-7.69-3.13-13.86-3.13h-24.42l-8.25,40.55h23.43c7.7,0,13.76-1.62,18.16-4.87,4.39-3.25,7.31-8.36,8.74-15.31.55-2.67.83-4.87.83-6.61,0-4.98-1.54-8.52-4.62-10.61Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvoroadsLogo);
export default __webpack_public_path__ + "static/media/evoroads_logo.ba5b01cec768f492bc0944d73beedd32.svg";
export { ForwardRef as ReactComponent };